
import React from 'react';
import { useSelector } from 'react-redux';
import isNil from 'lodash/isNil';

import { getUsekMezItems } from '../../reducers/project';

import SelectFileForImportDisabled from './SelectFileForImportDisabled.view';
import SelectFileForImportEnabled from './SelectFileForImportEnabled.view';

const SelectFileForImport = ({
    acceptFileType,
    loading,
    onUploadFile,
    onUseReadedItems,
    readFileResult
}) => {

    const usekMezItems = useSelector(state => getUsekMezItems(state.project));

    const isMapVisible = !isNil(usekMezItems);

    const handleContinueClick = () => {
        if (onUseReadedItems) {
            onUseReadedItems();
        }
    }

    const getCanContinue = () => {
        return (readFileResult && (readFileResult.items.length > 0));
    }

    const getReadedItemsCount = () => {
        return (readFileResult ? readFileResult.items.length : -1);
    }

    return (
        <>
            {isMapVisible &&
                <SelectFileForImportDisabled
                    readedItemsCount={getReadedItemsCount()}
                />
            }
            {!isMapVisible &&
                <SelectFileForImportEnabled
                    acceptFileType={acceptFileType}
                    canContinue={getCanContinue()}
                    loading={loading}
                    onContinueClick={handleContinueClick}
                    onUploadFile={onUploadFile}
                    readedItemsCount={getReadedItemsCount()}
                />
            }
        </>
    );
}

export default SelectFileForImport;
